import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { memo } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useScrollbarWidth } from 'react-use';
import { isSomeModalOpenSelector } from '@che-ins-ui/modal';
import { Container } from '@che-ins-ui/container';
import { Header as CheHeader } from '@che-ins-ui/header';
import { useCheTheme } from '@/styles/themes';
import { changingToThemeSelector, themeModeSelector, toggleTheme, } from '@/models/theme';
import { isIframe } from '@/libs/helpers';
import { useStyles } from './styles';
export const Header = memo(() => {
    const classes = useStyles();
    const dispatch = useDispatch();
    const isSomeModalOpen = useSelector(isSomeModalOpenSelector);
    const scrollbarWidth = useScrollbarWidth();
    const themeMode = useSelector(themeModeSelector);
    const paddingRight = isSomeModalOpen ? scrollbarWidth + 'px' : '0px';
    if (isIframe()) {
        return null;
    }
    return (_jsx("div", { className: classes.root, style: { paddingRight }, children: _jsx(Container, { children: _jsx(CheHeader, { contactsProps: { appearance: 'header' }, homepageUrl: __HOMEPAGE__, ...(themeMode === 'dark' && {
                    tooltipClasses: {
                        tooltipBody: classes.tooltipBodyDark,
                        tooltipArrow: classes.tooltipArrowDark,
                    },
                }), withThemeSwitcher: true, themeIcon: _jsx(ThemeModeSwitcher, {}), onThemeChange: () => dispatch(toggleTheme()) }) }) }));
});
const SIZE = 18;
const HALF_SIZE = SIZE / 2;
const CIRCLE_STROKE = 1.5;
const CENTER_SIZE = SIZE + 2;
const CIRCLE_DIMENSIONS = {
    cx: HALF_SIZE,
    cy: HALF_SIZE,
    r: HALF_SIZE - CIRCLE_STROKE,
};
const ThemeModeSwitcher = memo(() => {
    const theme = useCheTheme();
    const themeMode = useSelector(themeModeSelector);
    const changingToTheme = useSelector(changingToThemeSelector);
    const isLight = (changingToTheme || themeMode) === 'light';
    const posX = isLight ? -CENTER_SIZE : 0;
    const gradientStops = [
        { offset: '0', stopColor: theme.colors.yellow },
        { offset: '33.3%', stopColor: theme.colors.yellow },
        { offset: '66.6%', stopColor: theme.colors.white },
        { offset: '100%', stopColor: theme.colors.white },
    ];
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", width: SIZE, height: SIZE, viewBox: `0 0 ${SIZE} ${SIZE}`, fill: "none", children: [_jsxs("defs", { children: [_jsx("clipPath", { id: "clip", children: _jsx("circle", { ...CIRCLE_DIMENSIONS }) }), _jsx("linearGradient", { id: "gradient", x1: "0%", y1: "0%", x2: "100%", y2: "0%", children: gradientStops.map(({ offset, stopColor }) => (_jsx("stop", { offset: offset, style: { stopColor, stopOpacity: 1 } }, offset))) })] }), _jsx("g", { clipPath: "url(#clip)", children: _jsxs("g", { style: {
                        transform: `translateX(${posX}px)`,
                        transition: '0.4s cubic-bezier(0.22, 1, 0.36, 1)',
                    }, children: [_jsx("rect", { x: "0", y: "0", width: HALF_SIZE, height: SIZE }), _jsx("rect", { x: HALF_SIZE, y: "0", width: CENTER_SIZE, height: SIZE, fill: "url(#gradient)" }), _jsx("rect", { x: CENTER_SIZE + HALF_SIZE, y: "0", width: HALF_SIZE, height: SIZE })] }) }), _jsx("circle", { ...CIRCLE_DIMENSIONS, strokeWidth: CIRCLE_STROKE, fill: "none", stroke: isLight ? theme.colors.white : theme.colors.yellow, style: { transition: theme.transition.global } })] }));
});
